import React, { useEffect, useState } from "react";

import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar/Navbar";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

import "./admin.css";
import axios from "axios";


function Dashboard() {
  const [dataJadi, setData] = useState([]);
  // const [dataJadi, setDataJadi] = useState();
  useEffect(() => {
    document.title = "Lukopi - Dashboard";
    let empIncome = [];
    axios
      .get(`${process.env.REACT_APP_HOST_API}/transaction/all`)
      .then((result) => {
        for (const dataObj of result.data.data) {
          empIncome.push({
            date: new Date(dataObj.date).toLocaleDateString("id-ID"),
            income: parseInt(dataObj.income),
          });
        }
        // console.log(empIncome);
        setData(empIncome);
      })
      .catch((err) => console.log(err));
  }, []);

  // console.log(data)

  return (
    <>
      <Navbar page="dashboard" />
      <div className="container dashboard-container">
        <header className="dashboard-header">
          See how your store progress so far
        </header>
        <main className="section-dashboard-wrapper d-flex">
          <section className="left-section-dashboard d-flex">
            <div className="report-wrapper">
              <h2>Weekly Report</h2>
              <BarChart
                width={800}
                height={600}
                data={dataJadi}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
                barSize={20}
              >
                <XAxis
                  dataKey="date"
                  scale="point"
                  padding={{ left: 10, right: 10 }}
                />
                <YAxis />
                <Tooltip />
                <Legend />
                <CartesianGrid strokeDasharray="3 3" />
                <Bar
                  dataKey="income"
                  fill="#FFBA33"
                  background={{ fill: "#eee" }}
                />
              </BarChart>
            </div>
            <button className="download-report-btn">Download Report </button>
          </section>
          <section className="right-section-dashboard d-flex">
            <div className="monthly-award-section">
              <header className="d-flex">
                <img src="#" alt="img" />
                <div>
                  <p>Cheryn Laurent</p>
                  <span>Keep up the good work and spread love</span>
                </div>
              </header>
              <div>
                <p>Best Staff of the Month</p>
                <span>Achieved 3.5M of total 5M 478 Customers</span>
              </div>
            </div>
            <div className="goals-section">
              <header>
                <p>Goals</p>
                <span>Your goals is still on 76%. Keep up the good work!</span>
              </header>
            </div>
            <button className="share-report-btn">Share Report</button>
          </section>
        </main>
      </div>
      <Footer />
    </>
  );
}

export default Dashboard;
